import { render } from "./Camera.vue?vue&type=template&id=4253c437"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
script.render = render

export default script